export const languageEnglish = {
  action_delete: "Delete",
  actions: "Actions",
  add_item: "Add {subject}",
  browse_file: "browse",
  cancel: "Cancel",
  clear_cache: "Clear cache",
  clear_filtering: "Clear filtering",
  clone: "Clone",
  close_modal: "Close",
  close_modal_on_save: "Close modal on save",
  column_width_drag: "Drag the edges of any column below to change the width",
  columns: "Columns",
  confirm_delete: "Are you sure that you want to delete this item?",
  confirm_delete_multiple:
    "Are you sure that you want to delete those {items_amount} items?",
  edit: "Edit",
  edit_item: "Edit {subject}",
  enter_x_or_more_characters:
    "Please enter {remaining_chars} or more characters",
  error_empty_response:
    "The server returned an empty response (e.g. a blank page).",
  error_generic_title: "Something went wrong!",
  error_message: "Message",
  error_server_response: "Server Response",
  error_text: "Error",
  error_unknown_response: "We can't process the response of the server.",
  experimental_feature_short: "BETA",
  export_to_file: "Export",
  filtering_add_more: "Add more",
  filtering_and_statement: "AND",
  filtering_cancel: "Cancel",
  filtering_contains: "contains",
  filtering_does_not_have: "does not have",
  filtering_ends_with: "ends with",
  filtering_equals: "equals",
  filtering_filter_plural: "Filters",
  filtering_filter_single: "Filter",
  filtering_filter_text: "Filter",
  filtering_greater_than: "greater than",
  filtering_greater_than_or_equal: "greater than or equal",
  filtering_has: "has",
  filtering_is_empty: "is empty",
  filtering_is_not_empty: "is not empty",
  filtering_less_than: "less than",
  filtering_less_than_or_equal: "less than or equal",
  filtering_not_equals: "not equals",
  filtering_operator: "Operator",
  filtering_or_statement: "OR",
  filtering_remove_filter: "Remove filter",
  filtering_remove_filters: "Remove filters",
  filtering_starts_with: "starts with",
  filtering_text: "Filtering",
  loading: "Loading...",
  modal_save: "Save changes",
  more: "More",
  ordering_drag: "Drag a column to change their ordering",
  paging_displaying: "Displaying {start} to {end} of {results} items",
  paging_filtered_from: "(filtered from {total_results} total entries)",
  paging_show_entries: "Show {paging} entries",
  preview_as_html: "Preview as HTML",
  preview_as_plain_text: "Preview as plain text",
  print: "Print",
  quick_search: "Quick Search",
  refresh: "Refresh",
  reset_column_width: "Reset all column widths",
  reset_ordering: "Reset ordering",
  select_all: "Select All",
  select_an_option: "Select an option",
  select_some_options: "Select some options",
  settings: "Settings",
  subject: "Item",
  subject_plural: "Items",
  tab_ordering: "Ordering",
  tab_visibility: "Visibility",
  tab_width: "Width",
  time_hour_text: "Hour",
  time_minute_text: "Minute",
  time_second_text: "Second",
  time_text: "Time",
  upload_attach_file: "Drop files to attach, or {browse_file}",
  view: "View",
  view_item: "View {subject}",
};
